<template>
  <div class="section-header" data-comp="a-section-header">
    <a-mono-label v-if="label || blok.label">{{ label ? label : blok.label }}</a-mono-label>
    <a-header tag="p" classes="h2" class="section-header__title" v-if="title || blok.title">
      <span v-html="title ? title : blok.title"></span>
    </a-header>
  </div>
</template>

<script setup>
const props = defineProps({
  blok: {
    type: Object,
    default: () => ({}),
  },
  label: {
    type: String,
    default: "",
  },
  title: {
    type: String,
    default: "",
  },
});
</script>

<style lang="scss" scoped>
.section-header {
  display: flex;
  flex-direction: column;
  gap: 10px;

  @include global.breakpoint(mobile-landscape, min) {
    margin-bottom: 60px;
    align-items: center;
    flex-direction: row;
    justify-content: space-between;
  }

  &__title {
    display: flex;
    position: relative;
    text-transform: uppercase;

    @include global.breakpoint(mobile-landscape, min) {
      align-items: center;

      &::before {
        content: "";
        margin-right: 30px;
        width: calc(8.3333333333vw - 90px);
        min-width: 60px;
        height: 1px;
        background-color: var(--color-txt-secondary);
        z-index: 0;
        align-self: flex-start;
        margin-top: global.clampPx(mobile-portrait-small, desktop-large, 22px, 48px);
      }
    }
  }
}
</style>
